export default __webpack_public_path__ + "static/media/sound.7cdf0e02.svg";